import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/JobPage";
import GoogleJobsSchema from "@/ui/GoogleJobsSchema";
import { jobs_helper } from "@/helpers/jobs_helper";
import { getJobMetaDescription } from "@/functions/getJobMetaDescription";
import { parseRoute } from "@/functions/parseRoute";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content, job }) {
  return (
    <>
      <GoogleJobsSchema
        job={job}
        employment_type={JSON.stringify(
          job.categories.includes(sourceflowEnums.categories.type.contract) ? "CONTRACTOR" : "FULL_TIME"
        )}
        site_domain_link="https://www.gravitasgroup.com"
        site_name="Gravitas Recruitment Group"
        site_google_logo_link="https://www.gravitasgroup.com/favicon.ico"
      />
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const job = jobs_helper.find(url_slug);
  const similar = jobs_helper.getSimilarJobs({
    job,
    arrayOfCategoryIds: [sourceflowEnums.categories.sectors.id],
  });

  const routerProp = parseRoute("jobs.item", { url_slug });

  const location = job.derived_info?.locations?.[0].postal_address?.address_lines[0] ?? job.addresses[0];
  const inLocation = location && !location.includes("None Specified") ? ` in ${location}` : "";

  return {
    props: {
      meta: {
        en: {
          title: [`${job.title.trim()} Job${inLocation}`, job.salary_package].filter(Boolean).join(" | "),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
          description: getJobMetaDescription(job.description),
          images: [{ url: job?.image ?? sourceflowEnums.config.socialLogo }],
        },
      },
      router: routerProp,
      footer: { showForm: false },
      job,
      content: [
        { component: "JobPageIntroSection", props: { className: "", ...job } },
        {
          component: "JobPageContentSection",
          props: { className: "py-4 py-md-5", ...job, similar },
        },
      ],
    },
  };
}

export async function getStaticPaths() {
  const paths = jobs_helper
    .fetch({
      filter: ({ categories }) => JSON.stringify(categories).includes(sourceflowEnums.categories.sectors.internal),
    })
    .map(({ url_slug }) => ({ params: { url_slug } }));

  return {
    paths,
    fallback: false,
  };
}
